<!-- 滚动top列表 -->
<template>
    <swiper v-if="showData&&showData.length" class="progressbarList sort mt_5" :options="swiperOption" ref="swiperList">
        <!-- slides -->
        <swiper-slide v-for="(item,index) in showData" :key="index">
            <div class="item" :class="[labelType]">
                <div class="sortIcon" :class="['no'+(index+1)]">{{index+1}}</div>
                <div class="label c_pointer" @click="onClick(item.sName)">{{item.sName}}</div>
                <div class="valueBar flex_align" :class="{'broadBar':!hasValue}">
                    <div class="innerBar" :class="[theme]" :style="{'width':item.sValue/perBaseData * 100+'%'}">
                        <div class="innerSplit" v-if="hasInnerSplit"></div>
                        <template v-if="!hasValue">{{item.sValue}}</template>
                    </div>
                    <template v-if="hasValue">{{item.sValue}}</template>
                </div>
                <div class="value" v-if="hasValue" :class="{'alignRight':iconPosition=='after'}">
                    <!-- {{parseInt(Math.abs(item.iRange)*100)}}% -->
                    <template v-if="iconPosition=='after'">{{item.iRange=='-'?item.iRange:(parseInt(item.iRange*100)+'%')}}</template>
                    <i class="iconfont" :class="{
                        'icon-iconfont_up':item.iRangeType==1&&iconType=='triangle',
                        'icon-iconfont_down1':item.iRangeType==2&&iconType=='triangle',
                        'icon-iconfont_up1':item.iRangeType==1&&iconType=='arrow',
                        'icon-iconfont_down':item.iRangeType==2&&iconType=='arrow',
                        'icon-iconfont_equally c_999':item.iRangeType==0,
                    }"></i>
                    <template v-if="iconPosition=='before'">{{item.iRange=='-'?item.iRange:(parseInt(item.iRange*100)+'%')}}</template>
                </div>
            </div>
        </swiper-slide>
    </swiper>
</template>

<script>
import { swiper, swiperSlide} from 'vue-awesome-swiper'
export default {
    data() {
        return {
            // swiperOption: {
            //     direction: 'vertical',
            //     slidesPerView: 7,//设置slider容器能够同时显示的slides数量
            //     // loop:true,
            //     autoplay:{
            //         delay: 1000,
            //         disableOnInteraction:false,//操作后是否停止轮播
            //     },
            // },
        }
    },
    computed: {
        swiperOption() {
            return {
                direction: 'vertical',
                slidesPerView: 7,//设置slider容器能够同时显示的slides数量
                loop:this.showData.length>=7?true:false,
                autoplay:{
                    delay: 1000,
                    disableOnInteraction:false,//操作后是否停止轮播
                },
            }
        },
    },
    props:{
        showData:{
            type:Array,
            default(){
                return [];
            }
        },
        perBaseData:{//计算进度条长度的基准值
            default(){
                return 100;
            }
        },
        labelType:{//针对有些名称很长的列表
            default(){
                return '';
            }
        },
        theme:{//进度条的颜色  选值参考common.css line:742
            type:String,
            default(){
                return 'blue';
            }
        },
        hasInnerSplit:{//是否有分隔线
            type:Boolean,
            default(){
                return false;
            }
        },
        hasValue:{//是否显示最后面的value
            type:Boolean,
            default(){
                return true;
            }
        },
        iconType:{//图标类型 arrow：箭头 triangle：三角
            type:String,
            default(){
                return 'triangle';
            }
        },
        iconPosition:{//图标位置 before：value的前面 after：value的后面
            type:String,
            default(){
                return 'after';
            }
        },
    },
    components:{
        swiper,
        swiperSlide
    },
    methods: {
        onClick(name){
            this.$emit('labelClick',name);
        }
    },
}
</script>

<style lang="scss" scoped>

</style>
